<template>
    <div class="editor-opcoes-dropdown">
        <ItemMenuWrapper v-slot="{ inputId }" :label="label">
            <Button :id="inputId" @click="abrirModal" label="Abrir Painel de Edição" icon="pi pi-arrow-up-left" />
        </ItemMenuWrapper>

        <!-- Modal -->
        <Dialog v-model:visible="mostrarModal" modal header="Editar Opções do Select" style="min-width: 30vw">
            <div class="lista-opcoes">
                <div class="cabecalho-opcoes">
                    <strong style="flex: 2">Rótulo</strong>
                    <strong style="flex: 2">Valor</strong>
                    <strong style="flex: 1; padding-left: 8px">Ações</strong>
                </div>
                <div v-for="(opcao, index) in localOpcoes" :key="index" class="opcoes">
                    <InputText style="flex: 1" v-model="opcao.label" placeholder="Descrição" @input="emitirAtualizacao" />
                    <InputText style="flex: 1" v-model="opcao.value" placeholder="Valor" @input="emitirAtualizacao" />
                    <Button @click="mover(index, -1)" :disabled="index === 0" icon="pi pi-angle-up" />
                    <Button @click="mover(index, 1)" :disabled="index === localOpcoes.length - 1" icon="pi pi-angle-down" />
                    <Button @click="remover(index)" :disabled="localOpcoes.length <= 1" class="p-button-danger" icon="pi pi-trash" />
                </div>
            </div>
            <template #footer>
                <Button icon="pi pi-plus" @click="adicionar" label="Adicionar opção" />
                <Button @click="fecharModal" label="Fechar" />
            </template>
        </Dialog>
    </div>
</template>

<script setup>
import ItemMenuWrapper from './ItemMenuWrapper.vue';
import { ref, watch, defineProps, defineEmits } from 'vue';

const props = defineProps({
    modelValue: {
        type: Array,
        default: () => [],
    },
    label: {
        type: String,
    },
});

const emit = defineEmits(['update:modelValue']);

const mostrarModal = ref(false);
const localOpcoes = ref([...props.modelValue]);

watch(
    () => props.modelValue,
    (nova) => {
        localOpcoes.value = [...nova];
    }
);

function abrirModal() {
    mostrarModal.value = true;
}

function fecharModal() {
    mostrarModal.value = false;
}

function emitirAtualizacao() {
    emit('update:modelValue', localOpcoes.value);
}

function adicionar() {
    localOpcoes.value.push({
        label: `Opção ${localOpcoes.value.length + 1}`,
        value: `opcao_${localOpcoes.value.length + 1}`,
    });
    emitirAtualizacao();
}

function remover(index) {
    localOpcoes.value.splice(index, 1);
    emitirAtualizacao();
}

function mover(index, direcao) {
    const novaPosicao = index + direcao;
    if (novaPosicao < 0 || novaPosicao >= localOpcoes.value.length) return;
    const [item] = localOpcoes.value.splice(index, 1);
    localOpcoes.value.splice(novaPosicao, 0, item);
    emitirAtualizacao();
}
</script>

<style scoped lang="scss">
.lista-opcoes {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 8px;

    .cabecalho-opcoes {
        display: flex;
        flex-direction: row;
        gap: 8px;
        width: 100%;
    }

    .opcoes {
        display: flex;
        flex-direction: row;
        gap: 8px;
    }
}
</style>
